import './alert.css';

import React from 'react';
import { FormattedMessage } from 'react-intl';
import Modal from 'react-modal';
import PropTypes from 'prop-types';
import alertClose from './assets/icon-title-alert-close.svg';
import alertIcon from './assets/icon-title-alert.svg';
import { Link } from 'react-router-dom';

const showMessage = message => {
  if (message) {
    // console.log('message found');
    if (message.body.status) return message.body.status;
    if (message.body.message) return message.body.message;
    if (message.body.status) return message.body.status;
    if (message.data) {
      return `below files are failed to translate:${message.data}`;
    }
  }

  return 'General Server Error';
};

const Comfirm = ({ pagetitle, message, popwindow, nextpage, onClose }) => (
    <Modal
      isOpen={popwindow}
      contentLabel="Alert"
      className="modal"
      overlayClassName="overlay"
    >
      <div className="alert">
        <div className="alert-header">
          <img alt="" src={alertIcon} />
          Confirmation
        </div>
        <div className="alert-content">
          <p>
            <FormattedMessage
              id="alert.paragraph1"
              defaultMessage="Are you sure you want to continue?"
            />
          </p>
        </div>
        <button className="button" onClick={onClose}>
          Cancel
        </button>
        <Link to={nextpage}>
          <button className="button" type="button">
            OK
          </button>
        </Link>
        <div className="close" onClick={onClose}>
          <img alt="" src={alertClose} />
        </div>
      </div>
    </Modal>
  );
// const closeModal = () => {
//   localStorage.clear();
//   sessionStorage.clear();
//   document.location.pathname = '/en-CA/login';
// };

Comfirm.propTypes = {
  pagetitle: PropTypes.string.isRequired,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  message: PropTypes.object
};

export default Comfirm;



// WEBPACK FOOTER //
// ./src/components/elements/Comfirm/index.js